const routes = [
  {
    path: 'normal',
    name: 'auth.normal',
    children: [
      {
        path: 'login',
        name: 'normal.login',
        component: () =>
          import(
            /* webpackChunkName: "normalAuth" */ '@/modules/auth/normal/views/LoginView.vue'
          ),
        meta: {
          hide: true,
          title: 'LOGIN',
        },
      },
      {
        path: 'register',
        name: 'normal.register',
        component: () =>
          import(
            /* webpackChunkName: "normalAuth" */ '@/modules/auth/normal/views/RegisterView.vue'
          ),
        meta: {
          hide: true,
          title: 'CREATE ACCOUNT',
        },
      },
      {
        path: 'forgot-password',
        name: 'normal.forgot.password',
        component: () =>
          import(
            /* webpackChunkName: "normalAuth" */ '@/modules/auth/normal/views/PasswordRecoveryView.vue'
          ),
        meta: {
          hide: true,
          title: 'FORGOT PASSWORD',
        },
      },
      {
        path: 'verify-otp',
        name: 'normal.verify.otp',
        component: () =>
          import(
            /* webpackChunkName: "normalAuth" */ '@/modules/auth/normal/views/VerifyOtpView.vue'
          ),
        meta: {
          hide: true,
          title: 'ACCOUNT VERIFICATION',
        },
      },
      {
        path: 'reset-password',
        name: 'normal.reset.password',
        component: () =>
          import(
            /* webpackChunkName: "normalAuth" */ '@/modules/auth/normal/views/ResetPasswordView.vue'
          ),
        meta: {
          hide: true,
          title: 'RESET PASSWORD',
        },
      },
    ],
  },
];

export default routes;
